import { AttachmentsCard } from "../attachments/AttachmentsCard";

/** A work item's files. The card itself is shared with meetings. */
export function WorkItemAttachments({ workItemId }: { workItemId: string }) {
  return (
    <AttachmentsCard
      entityType="WORK_ITEM"
      entityId={workItemId}
      emptyMessage="Nothing attached. Screenshots on a bug and designs on a story are worth far more here than in a chat thread nobody can find later."
    />
  );
}
